import { Typography } from 'antd';
import type { FC } from 'react';
import { formatTimeRemaining, getMinutesLeftLikeSchedule } from '../utils/expressOrdersUtils';

const { Text } = Typography;

export const OrderScheduleInfo: FC<{
  plannedDate: string;
  plannedDateDuration?: number | null;
  departmentTimeZone: number;
  isExpress?: boolean;
  statusName?: string;
}> = ({ plannedDate, plannedDateDuration, departmentTimeZone, isExpress, statusName }) => {
  if (!isExpress) {
    return null;
  }

  if (statusName === 'Delivered') {
    return null;
  }

  const orderForCalculation = {
    plannedDate,
    plannedDateDuration: plannedDateDuration ?? null,
  } as Parameters<typeof getMinutesLeftLikeSchedule>[0];

  const minutesLeft = getMinutesLeftLikeSchedule(orderForCalculation, departmentTimeZone);
  if (minutesLeft == null) {
    return null;
  }

  const timeRemainingText = formatTimeRemaining(minutesLeft);

  if (!timeRemainingText) {
    return null;
  }

  return (
    <div style={{ marginTop: 4 }}>
      <Text
        className={
          minutesLeft < 15
            ? 'express-time-critical'
            : minutesLeft < 30
              ? 'express-time-warning'
              : 'express-time-ok'
        }
        style={{ fontSize: '12px', fontWeight: 'bold' }}
      >
        {timeRemainingText}
      </Text>
    </div>
  );
};
